
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    textPadding: {
      // 文字默认间距
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      isShowClone: false,
      isScroll: false,
      id: this.uuid(),
      animation: null,
      scrollVal: 0,
      wikiScrollStyle: null
    }
  },
  computed: {
    scrollWidth() {
      if (!this.$refs[`wikiTextScroll_${this.id}`]) return 0
      return this.$refs[`wikiTextScroll_${this.id}`].getBoundingClientRect().width
    },
    textWidth() {
      if (!this.$refs[`textWarp_${this.id}`]) return 0
      return this.$refs[`textWarp_${this.id}`].getBoundingClientRect().width
    }
  },
  mounted() {
    // 文字内容小于盒子宽度不能滚动
    this.$nextTick(() => {
      if (this.textWidth > this.scrollWidth) {
        this.isShowClone = true
        this.isScroll = true
        this.startMove(this.scrollVal)
      } else {
        this.isScroll = false
      }
    })
  },
  methods: {
    txtMouseover() {
      this.isScroll = false
    },
    txtMouseout() {
      if (!this.isShowClone) return
      this.isScroll = true
      this.$nextTick(() => {
        this.startMove(this.scrollVal)
      })
    },
    startMove(w) {
      this.wikiScrollStyle = {
        transform: `translate(-${w}px, 0px)`,
        transition: 'all 0ms ease-in 0s',
        width: `${Math.trunc(this.textWidth) * 2}px`
      }
      if (w - this.textPadding >= this.textWidth) {
        this.scrollVal = 0
      } else {
        this.scrollVal = this.scrollVal + 0.4
      }
      if (!this.isScroll) return
      window.requestAnimationFrame(() => {
        this.startMove(this.scrollVal)
      })
    },
    uuid() {
      const s = []
      const hexDigits = '0123456789abcdef'
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4'
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = '-'
      this.uuidA = s.join('')
      return this.uuidA
    }
  }
}
